import { useFetch } from './useFetch'
import useAlert from '../alert/useAlert'
import { AlertVariants } from '../../context/Alert/AlertContext'
import {
    CreateCustomReportBody,
    CustomReportResponse,
    GetCustomReportsResponse,
    UpdateCustomReportBody
} from '../../interfaces/customReport'

export const useCustomReportsFetch = () => {
    const { setTypeGlobalAlert, setShowGlobalAlert, setMessageGlobalAlert, setPositionAlert } = useAlert()
    const { authFetch } = useFetch()

    const BASE_URL = process.env.REACT_APP_AUTH_API_URL + '/api/admin/custom-reports'

    const getReports = async (
        page: number,
        limit: number,
        country_id?: number,
        search?: string
    ): Promise<GetCustomReportsResponse> => {
        let result: GetCustomReportsResponse = {
            success: false,
            data: [],
            total: 0,
            message: ''
        }

        try {
            const body: any = { page, limit }
            if (country_id) body.country_id = country_id
            if (search) body.search = search

            const response = await authFetch(`${BASE_URL}/list`, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                }
            })

            if (!response.error) {
                result = response
            } else {
                result.message = response.message || 'Error al obtener los reportes'
            }
        } catch (error) {
            console.error('Error en getReports:', error)
        }

        return result
    }

    const createReport = async (body: CreateCustomReportBody): Promise<CustomReportResponse> => {
        let result: CustomReportResponse = { success: false, message: '' }

        try {
            const formData = new FormData()
            formData.append('country_id', body.country_id.toString())
            formData.append('slug', body.slug)
            formData.append('sandboxed', body.sandboxed ? 'true' : 'false')
            if (body.title) formData.append('title', body.title)
            formData.append('reportFile', body.file)

            const response = await authFetch(`${BASE_URL}/create`, {
                method: 'POST',
                body: formData,
                headers: { 'Cache-Control': 'no-cache' }
            })

            if (!response.error) {
                result = response
            } else {
                result.message = response.message || 'Error al publicar el reporte'
            }
        } catch (error) {
            console.error('Error en createReport:', error)
        }

        return result
    }

    const updateReport = async (body: UpdateCustomReportBody): Promise<CustomReportResponse> => {
        let result: CustomReportResponse = { success: false, message: '' }

        try {
            const formData = new FormData()
            formData.append('id', body.id.toString())
            if (body.slug !== undefined) formData.append('slug', body.slug)
            if (body.title !== undefined) formData.append('title', body.title)
            if (body.active !== undefined) formData.append('active', body.active ? 'true' : 'false')
            if (body.sandboxed !== undefined) formData.append('sandboxed', body.sandboxed ? 'true' : 'false')
            if (body.file) formData.append('reportFile', body.file)

            const response = await authFetch(`${BASE_URL}/update`, {
                method: 'POST',
                body: formData,
                headers: { 'Cache-Control': 'no-cache' }
            })

            if (!response.error) {
                result = response
            } else {
                result.message = response.message || 'Error al actualizar el reporte'
            }
        } catch (error) {
            console.error('Error en updateReport:', error)
        }

        return result
    }

    const deleteReport = async (id: number): Promise<CustomReportResponse> => {
        let result: CustomReportResponse = { success: false, message: '' }

        try {
            const response = await authFetch(`${BASE_URL}/delete/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                }
            })

            if (!response.error) {
                result = response
            } else {
                result.message = response.message || 'Error al eliminar el reporte'
            }
        } catch (error) {
            console.error('Error en deleteReport:', error)
        }

        return result
    }

    // Mostrar alerta global
    const showAlertMessage = (type: AlertVariants, message: string) => {
        setPositionAlert('bottom')
        setTypeGlobalAlert(type)
        setMessageGlobalAlert(message)
        setShowGlobalAlert(true)
        setTimeout(() => {
            setShowGlobalAlert(false)
            setTypeGlobalAlert('success')
            setMessageGlobalAlert('')
            setPositionAlert('top')
        }, 3000)
    }

    return {
        getReports,
        createReport,
        updateReport,
        deleteReport,
        showAlertMessage
    }
}
